export type BoundedCache<T> = { entries: Map<string, T>; limit: number };

export const boundedCache = <T>(limit: number): BoundedCache<T> => ({
  entries: new Map(),
  limit,
});

export const cached = <T>(
  { entries, limit }: BoundedCache<T>,
  key: string,
  build: () => T
) => {
  const existing = entries.get(key);
  if (existing !== undefined) {
    entries.delete(key);
    entries.set(key, existing);
    return existing;
  }
  const value = build();
  entries.set(key, value);
  if (entries.size > limit) {
    const oldest = entries.keys().next().value;
    if (oldest !== undefined) entries.delete(oldest);
  }
  return value;
};
